import { AnimatePresence } from 'framer-motion';
import { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import AppFooter from './components/shared/AppFooter';
import AppHeader from './components/shared/AppHeader';
import './css/App.css';
import UseScrollToTop from './hooks/useScrollToTop';
import { ProjectsProvider } from './context/ProjectsContext';
import ScrollToHash from './components/ScrollToHash';


const About = lazy(() => import('./pages/AboutMe'));
const Contact = lazy(() => import('./pages/Contact.jsx'));
const Home = lazy(() => import('./pages/Home'));
const Projects = lazy(() => import('./pages/Projects'));
const ProjectSingle = lazy(() => import('./pages/ProjectSingle.jsx'));

function App() {
	return (
		<AnimatePresence>
			<div className="bg-secondary-light dark:bg-primary-dark transition duration-300">
				<Router>
					<ProjectsProvider>
						<ScrollToTop />
						<ScrollToHash />
						<AppHeader />

						<Suspense fallback={""}>
							<Routes>
								<Route
									path="/"
									element={
										<>
											<Home />
											<About />
											<Contact />
										</>
									}
								/>

								<Route path="/projects" element={<Projects />} />
								<Route path="/projects/:id" element={<ProjectSingle />} />
							</Routes>
						</Suspense>

						<AppFooter />
					</ProjectsProvider>
				</Router>

				<UseScrollToTop />
			</div>
		</AnimatePresence>
	);
}

export default App;
